import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "./My_Table.css";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import {
  deleteData,
  editStatusData,
  getData,
  getDownloadDataExcel,
  postData,
} from "../../../../utils/api";
import { Link } from "react-router-dom";
import { ApprovalStatus, RoleId, Select2Data } from "../../../../utils/common";
import LinkProductsModel from "../LinkProductsModel";
import { DeletButton } from "../../../common/Button";
import ModalDelete from "../../../common/ModelDelete";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProductViewModal from "../ProductViewModal";
import AddStoreModal from "../AddStoreModal";
import {
  fas,
  faBarsStaggered,
  faFilter,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import ProductDiscount from "../ProductDiscount";

function My_Table({
  data,
  getDataAll,
  handleRefreshProducts,
  OrderByOptions,
  user,
  reset,
  setonPageChange,
  store_id,
  setStoreId,
  vendors,
  paramid,
  setChangeStatus,
  // sortOrder,
  // setSortOrder,
  resultsPerPageOptions,
  perPage,
  setperPage,
  setReset,
  hideFilter,
  setHideFilter,
  option,
  setStoreCategory,
  childCategories,
  subCategories,
  categories,
  setSearchCategory,
  setSearchSubCategory,
  setSearchChildCategory,
  searchChildCategory,
  searchSubCategory,
  searchCategory,
  getAllSubCategories,
  getAllChildCategories,
  setSearch,
  search,
  searchDateTo,
  searchDateFrom,
  setSearchDateTo,
  setSearchDateFrom,
  setSubCategories,
  setChildCategories,
  HandleDownload,
  HandleDownloadProductOrder,
  refreshing,
  searchName,
  searchDesignId,
  setSearchDesignId,
  setSearchName,
}) {
  const { IMG_URL, ErrorNotify } = useContext(Context);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const [showModel, setShowModel] = useState(0);

  const [showViewModal, setShowViewModal] = useState(false);

  const [singleProduct, setSingleProduct] = useState({});

  const handleViewProduct = async (itemID) => {
    try {
      const response = await getData(`/admin/products/${itemID}`);

      if (response?.success) {
        setSingleProduct(response?.data);
        setShowViewModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [showStoreModal, setShowStoreModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleStoreModal = (product) => {
    setSelectedProduct(product);
    setShowStoreModal(true);
  };

  const [showPaking, setShowPaking] = useState({ show: 0, data: {} });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  console.log("option", option);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeStoreStatus = async (id, option) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/products/status/${id}`, {
        approval_status_id: option,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/products/${recordToDeleteId}`);
      if (response?.success) {
        getDataAll();
      }

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/products/${id}`);
    setChangeStatus(response);
  };

  const ChangeTopPick = async (id) => {
    const response = await editStatusData(`/admin/products/top-pick/${id}`);
    setChangeStatus(response);
  };

  const ChangeSeasonable = async (id) => {
    const response = await editStatusData(
      `/admin/products/seasonable-status/${id}`,
    );
    setChangeStatus(response);
  };
  const ChangeBestSeller = async (id) => {
    const response = await editStatusData(
      `/admin/products/best-seller-status/${id}`,
    );
    setChangeStatus(response);
  };

  const [sortBy, setSortBy] = useState("stock");
  const [sortOrder, setSortOrder] = useState("asc");
  const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
    if (sortBy === "price") {
      const priceA = Number(a?.price || 0);
      const priceB = Number(b?.price || 0);

      return sortOrder === "asc" ? priceA - priceB : priceB - priceA;
    }

    if (sortBy === "stock") {
      const stockA = Number(a?.stock || 0);
      const stockB = Number(b?.stock || 0);

      return sortOrder === "asc" ? stockA - stockB : stockB - stockA;
    }
    return 0;
  });

  // const [sortBy, setSortBy] = useState("stock");

  // const [sortOrder, setSortOrder] = useState("asc");

  // const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
  //   if (sortBy === "price") {
  //     return sortOrder === "asc"
  //       ? Number(a?.SALEPRICE || 0) - Number(b?.SALEPRICE || 0)
  //       : Number(b?.SALEPRICE || 0) - Number(a?.SALEPRICE || 0);
  //   } else {
  //     return sortOrder === "asc"
  //       ? Number(a?.BALQTY || 0) - Number(b?.BALQTY || 0)
  //       : Number(b?.BALQTY || 0) - Number(a?.BALQTY || 0);
  //   }
  // });

  return (
    <section className="pending-table_holder">
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-xl-3 col-lg-4 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                id=""
                value={searchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                }}
              />
            </div>

            <div className="col-xl-3 col-lg-4 mb-2">
              <Form.Label>Design ID</Form.Label>
              <Form.Control
                placeholder="Enter Design ID"
                value={searchDesignId}
                onChange={(e) => setSearchDesignId(e.target.value)}
              />
            </div>

            <div className="col-xl-3 col-lg-4 mb-2">
              <Form.Label>Select Category </Form.Label>
              <Select
                isSearchable
                options={categories}
                value={searchCategory}
                placeholder="Select Category"
                onChange={(e) => {
                  setSearchCategory(e);

                  setSearchSubCategory(null);
                  setSearchChildCategory(null);

                  setSubCategories([]);
                  setChildCategories([]);

                  getAllSubCategories(e.value);
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-xl-3 col-lg-4 mb-2">
              <Form.Label>Select Sub Category </Form.Label>
              <Select
                isSearchable
                options={subCategories}
                value={searchSubCategory}
                placeholder="Select Sub Category"
                onChange={(e) => {
                  setSearchSubCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            {/* <div className="col-xl-3 col-lg-4 mb-2">
              <Form.Label>Select Child Category </Form.Label>
              <Select
                isSearchable
                options={childCategories}
                value={searchChildCategory}
                placeholder="Select Child Category"
                onChange={(e) => {
                  setSearchChildCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div> */}
          </div>
        </div>
      </div>

      <div className="row mb-3">
        {/* <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div> */}
        <div className="col-md-3 mb-2">
          <Form.Label>Start Date</Form.Label>
          <input
            type="date"
            className="form-control"
            value={searchDateFrom}
            onChange={(e) => {
              const value = e.target.value;
              const year = value.split("-")[0];

              if (year.length === 4 || value === "") {
                setSearchDateFrom(value);
                setonPageChange(1);
              }
            }}
          />
        </div>
        <div className="col-md-3">
          <div className="num me-2">
            <label className="form-label">End Date</label>
            <input
              type="date"
              className="form-control"
              placeholder="to"
              value={searchDateTo}
              onChange={(e) => {
                setSearchDateTo(e.target.value);
                setonPageChange(1);
              }}
            />
          </div>
        </div>

        {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Net sell Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div> */}

        {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownloadProductOrder}
                >
                  Product Order Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div> */}
        <div className="col-xl-3 col-lg-4 mb-2">
          <Form.Label>Sort According </Form.Label>
          <Select
            // options={[
            //   { label: "Order Count", value: "orders" },
            //   { label: "Total Price", value: "price" },
            // ]}
            options={[
              { label: "Stock", value: "stock" },
              { label: "Sale Price", value: "price" },
            ]}
            value={{
              // label: sortBy === "orders" ? "Order Count" : "Total Price",
              label: sortBy === "stock" ? "Stock" : "Sale Price",
              value: sortBy,
            }}
            onChange={(e) => setSortBy(e.value)}
            placeholder="Sort By"
          />
        </div>

        <div className="col-xl-3 col-lg-4 mb-2">
          <Form.Label>Order </Form.Label>
          <Select
            options={[
              { label: "Ascending", value: "asc" },
              { label: "Descending", value: "desc" },
            ]}
            value={{
              label: sortOrder === "asc" ? "Ascending" : "Descending",
              value: sortOrder,
            }}
            onChange={(e) => setSortOrder(e.value)}
            placeholder="Sort Order"
          />
        </div>

        <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
          <div className="Search me-2">
            <Button
              type="button"
              onClick={getDataAll}
              className="btn btn-search"
            >
              <img src={search1} className="search" alt="" />
            </Button>
          </div>
        </div>
        <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
          <div className="Search-1">
            <button
              type="button"
              onClick={() => {
                setSearch("");
                setSearchDateFrom("");
                setSearchDateTo("");
                setSearchCategory("");
                setSearchChildCategory("");
                setSearchSubCategory("");
                setSearchName("");
                setSearchDesignId("");

                // reset sorting
                setSortBy("stock");
                setSortOrder("asc");

                // reset pagination
                setonPageChange(1);

                // reset per page if needed
                setperPage({
                  value: 25,
                  label: "Results per page: 25",
                });
                setReset(!reset);
              }}
              className="btn btn-reset"
            >
              Reset
            </button>
          </div>
        </div>

        <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
          {/* <Form.Label></Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Download Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div> */}
          <div className="add me-3">
            <button
              className="btn btn-add pe-3"
              type="button"
              onClick={handleRefreshProducts}
              disabled={refreshing}
            >
              <FontAwesomeIcon
                icon={faRotateRight}
                className={`me-2 ${refreshing ? "fa-spin" : ""}`}
              />

              {refreshing ? "Refreshing..." : "Refresh Products"}
            </button>
          </div>
        </div>
      </div>

      {/* <div className="filters-section mb-3">
        <div className="filters-section__label">
          <Button
            className="hide_btn mb-3"
            onClick={() => {
              setHideFilter(!hideFilter);
              setStoreCategory("");
              setSortOrder({
                value: "DESC",
                label: "Sort-by date (Descending)",
              });
              setperPage({ value: 25, label: "Results per page: 25" });
              setReset();
            }}
          >
            {" "}
            {!hideFilter ? "Hide Filter" : "Show Filter"}
          </Button>
          <h6>
            <span>{data?.data?.total} Products</span>
           
          </h6>
        </div>
        {!hideFilter && (
          <div className="filters-section__controls">
            <div className="row">
              <div className="col-lg-3 mb-2">
                <Select
                  options={OrderByOptions}
                  // defaultValue={OrderByOptions[0]}
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <Select
                  options={resultsPerPageOptions}
                  // defaultValue={resultsPerPageOptions[0]}
                  value={perPage}
                  onChange={(e) => setperPage(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                {user && user?.role_id === RoleId.Admin && (
                  <Select
                    options={vendors}
                    value={
                      store_id
                        ? vendors.find((vendor) => vendor.value === store_id)
                        : null
                    }
                    onChange={(e) => setStoreId(e?.value)}
                    className="filters-section__dropdown"
                    classNamePrefix="react-select"
                    styles={customSelectStyles}
                  />
                )}
              </div>
              <div className="col-lg-3 mb-2">
                <Button
                  variant="outline-secondary"
                  className="filters-section__btn active me-1"
                  onClick={() => {
                    setonPageChange(1);
                    getDataAll();
                  }}
                >
                  Set Table Preferences
                </Button>

                <Button
                  variant="outline-secondary"
                  className="filters-section__btn"
                  onClick={() => {
                    setStoreCategory("");
                    setStoreId("");
                    setSortOrder({
                      value: "DESC",
                      label: "Sort-by date (Descending)",
                    });
                    setperPage({ value: 25, label: "Results per page: 25" });
                    setonPageChange(1);
                    setReset(!reset);
                  }}
                >
                  Refresh
                </Button>
              </div>
            </div>

           
          </div>
        )}
      </div> */}

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              {/* <th>Creation Date</th> */}
              <th>Product details</th>
              {/* <th>Store details</th> */}
              <th>Image</th>
              <th>Categories</th>
              {/* <th>Total Order</th> */}
              {/* <th>Price Details</th> */}
              <th>Description</th>
              {/* <th>Store Name</th> */}
              {/* {user && user?.role_id === RoleId.Vendor && */}
              {/* <th>View</th> */}
              {/* } */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((item, index) => (
              <tr key={index}>
                {/* <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td> */}

                {/* Owner Details */}
                <td className="order-details">
                  {/* <div className="order-id text-highlight">
                    <b>Bar Code: </b>
                    <span>{item?.item_code}</span>
                  </div> */}
                  {/* <div className="order-id text-highlight">
                    <b>Design ID: </b>
                    <span>{item?.PRINTNAME}</span>
                  </div> */}
                  <div className="order-info">
                    <span className="text-highlight">
                      <b>Item Name: </b> {item?.name}
                    </span>
                  </div>
                  <div className="order-info">
                    <b>Design ID: </b> {item?.design_id || "N/A"}
                  </div>
                  {/* <div className="order-info">
                    <b>SKU Code: </b> {item?.sku_code || "N/A"}
                  </div> */}
                  {/* <div className="order-info">
                    <span>{item?.price} / {item?.Unit?.name}</span>
                  </div> */}
                  {/* {item?.Brand &&
                    item?.Brand != null &&
                    item?.Brand != "" &&
                    item?.Brand != "N/A" && (
                      <div className="order-info">
                        <div className="order-id">
                          <span>
                            <b>Brand: </b>
                            {item?.Brand?.name}
                          </span>
                        </div>
                      </div>
                    )} */}

                  {/* {item?.Colour &&
                    item?.Colour != null &&
                    item?.Colour != "" &&
                    item?.Colour != "N/A" && (
                      <div className="order-info">
                        <div className="order-id">
                          <span>
                            <b>Color: </b>
                            {item?.Colour?.name}{" "}
                          </span>
                        </div>
                      </div>
                    )}

                  {item?.Size &&
                    item?.Size != null &&
                    item?.Size != "" &&
                    item?.Size !== "N/A" && (
                      <div className="order-info">
                        <div className="order-id">
                          <span>
                            <b>Size: </b>
                            {item?.Size?.name}{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  <div className="order-info">
                    <div className="order-id">
                      <span>
                        <b>Balance Quantity: </b>
                        {item?.stock}{" "}
                      </span>
                    </div>
                  </div> */}
                </td>

                <td>
                  <div className="d-flex flex-wrap gap-2">
                    {[item?.image]
                      .filter((img) => img && img.trim() !== "")
                      .map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Product-${index + 1}`}
                          className="product-image"
                          style={{
                            width: "70px",
                            height: "70px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                          }}
                        />
                      ))}
                  </div>
                </td>

                <td className="order-details">
                  <div className="order-info">
                    <b>Category:</b> {item?.p_category?.name}
                  </div>

                  <div className="order-info">
                    <b>Sub Category:</b> {item?.p_sub_category?.name}
                  </div>

                  {/* <div className="order-info">
                    <b>Polish:</b> {item?.Polish?.name}
                  </div> */}
                  {/* <div className="order-info">
                    <div className="order-id">Manufacturer:</div>
                    <span>{item?.manufacturer} </span>
                  </div> */}
                </td>

                {/* <td className="order-details">
                  <div className="order-info">
                    <span>
                      <b>MRP: </b>₹ {item?.mrp}
                    </span>
                  </div>

                  <div className="order-info">
                    <span>
                      <b>Sale Price: </b>₹ {item?.price}
                    </span>
                  </div>
                </td> */}

                <td>
                  <div className="order-info">
                    <b>Bar Code: </b> {item?.item_code}
                  </div>

                  {item?.prod_discount && (
                  <div className="order-info">
                    <b>Product Discount: </b> {item?.prod_discount}(%)
                  </div>
                  )}

                  {item?.description &&
                    item?.description != null &&
                    item?.description !== "" &&
                    item?.description !== "N/A" && (
                      <div className="order-info">
                        <b>Description: </b> {item?.description || "N/A"}
                      </div>
                    )}

                  {item?.Earring_style &&
                    item?.Earring_style != null &&
                    item?.Earring_style !== "" &&
                    item?.Earring_style !== "N/A" && (
                      <div className="order-info">
                        <b>Earring Style: </b>{" "}
                        {item?.Product_Variants?.earring_style}
                      </div>
                    )}

                  {item?.Product_Variants?.neckalace_style &&
                    item?.Product_Variants?.neckalace_style != null &&
                    item?.Product_Variants?.neckalace_style !== "" &&
                    item?.Product_Variants?.neckalace_style !== "N/A" && (
                      <div className="order-info">
                        <b>Necklace Style: </b>{" "}
                        {item?.Product_Variants?.neckalace_style}
                      </div>
                    )}
                </td>

                {/* <td>
                  <Button
                    className="action-btn active"
                    onClick={() => handleViewProduct(item?.id)}
                  >
                    View Product
                  </Button>
                </td> */}

                {/* <td>
                  <div className="order-info">
                    <span>
                      {" "}
                      <b>No Of order</b>{" "}
                      {item?.Product_Order_Details?.length}{" "}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      <b>Total Price</b>: ₹
                      {item?.Product_Order_Details?.reduce((sum, detail) => {
                        return sum + parseFloat(detail?.total_amount || 0);
                      }, 0).toFixed(2)}
                    </span>
                  </div>
                </td> */}

                {/* <td>
                  <div className="order-info">
                    <span>{item?.description} </span>
                    {item?.tax_percentage && (
                      <>
                        <div className="order-id">Tax</div>
                        <span>{item?.tax_percentage} % </span>
                      </>
                    )}
                  </div>
                </td> */}

                {/* <td>
                  {item?.Often_Ordered_Withs?.map((item) => (
                    <div key={item?.id} className="order-info">
                      <span className="text-highlight"> {item?.linked_product?.name}</span>
                    </div>
                  ))}

                  
                  <Button
                    className="action-btn my-1"
                    onClick={() =>
                      setShowModel(item?.id)
                    }
                    style={{ marginTop: "auto" }}
                  >
                    Edit
                  </Button>
                

                </td> */}

                {/* {user && user?.role_id === RoleId.Vendor && */}
                {/* <td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.status}
                        onChange={() => {
                          ChangeStatus(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`flexSwitchCheckDefault${item?.id}`}
                      >
                        {item?.status ? "Active" : "Inactive"}
                      </label>
                    </div>

                    <label
                      className="form-check-label"
                      htmlFor={`flexSwitchCheckDefault${item?.id}`}
                    >
                      All-Time Favs ?
                    </label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.is_replaceble}
                        onChange={() => {
                          ChangeTopPick(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                    </div>

                    <label
                      className="form-check-label"
                      htmlFor={`flexSwitchCheckDefault${item?.id}`}
                    >
                      OUR CHOICE ?
                    </label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.seasonable_status}
                        onChange={() => {
                          ChangeSeasonable(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                    </div>

                    <label
                      className="form-check-label"
                      htmlFor={`flexSwitchCheckDefault${item?.id}`}
                    >
                      Best Seller ?
                    </label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.best_seller_status}
                        onChange={() => {
                          ChangeBestSeller(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                    </div>
                  </td>
                </td> */}
                {/* } */}

                {/* <td>
                  {item?.Product_Stores?.map(
                      (val) => val?.Store?.name,
                    )?.join(", ")}

                </td> */}

                <td>
                  {/* {user && user?.role_id === RoleId.Admin &&
                    <select
                      className={item?.approval_status_id === ApprovalStatus.Approved ? "status-holder shipped" : "status-holder Unshipped"}
                      onChange={(e) => ChangeStoreStatus(item?.id, e.target.value)}
                      value={item?.Approval_Status?.id}
                    >
                      <option value={ApprovalStatus.Pending}>Inactive</option>
                      <option value={ApprovalStatus.Approved}>Approved</option>
                      <option value={ApprovalStatus.Rejected}>Rejected</option>
                    </select>
                  } */}
                  {/* {user && user?.role_id === RoleId.Vendor && */}
                  <div className="my-1">
                    <Link to={`/product/edit/${item?.id}`}>
                      <Button className="action-btn active">View</Button>
                    </Link>
                    {/* <div className="my-1">
                      <Button
                        className="action-btn "
                        onClick={() => showDeleteRecord(item?.id, item?.name)}
                      >
                        Delete
                      </Button>
                    </div> */}

                    {/* <Button
                      variant="success"
                      size="sm"
                      className="mx-1 mt-2"
                      onClick={() => handleStoreModal(item?.id)}
                    >
                      Add Store
                    </Button> */}
                  </div>
                  {/* } */}
                 
                  <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() =>
                        setShowPaking({
                          show: item?.id,
                          data: item,
                        })
                      }
                    >
                      {item?.prod_discount != null
                        ? "Edit Product Discount"
                        : "Enter Product Discount"}
                    </Button>
                  </div>
               
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <LinkProductsModel
        user={user}
        show={showModel}
        handleClose={() => {
          setShowModel(0);
          getDataAll();
        }}
      />
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
      <ProductViewModal
        show={showViewModal}
        handleClose={() => {
          setShowViewModal(false);
          setSingleProduct({});
        }}
        product={singleProduct}
      />

      <ProductDiscount
        handleClose={() => {
          setShowPaking({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowPaking({ show: 0, data: {} })}
        show={showPaking?.show}
        data={showPaking?.data}
      />

      <AddStoreModal
        show={showStoreModal}
        productId={selectedProduct}
        handleClose={() => {
          setShowStoreModal(false);
          setSelectedProduct(null);
          getDataAll();
        }}
      />
    </section>
  );
}

export default My_Table;
